import React, { useMemo } from "react";
import moment from "moment";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { diffYMD, formatDateToDDMMYYYY } from "utils/CommonFunctions";

const PatientRegistrationModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  const calculateAges = useMemo(() => {
    const formatDOB = (dob) => {
      if (!dob) return "";
      const formattedDob = moment(new Date(dob)).format("DD/MM/YYYY");
      const currentDate = moment();
      const dobMoment = moment(formattedDob, "DD/MM/YYYY");
      const age = diffYMD(currentDate, dobMoment);
      return age || "";
    };

    return {
      patientAge: formatDOB(activePatientJourneyModuleDetails?.patient_dob),
      partnerAge: formatDOB(activePatientJourneyModuleDetails?.partner_dob),
    };
  }, [activePatientJourneyModuleDetails]);

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Patient Registration Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        width={860}
      >
        <div className="modal-details">
          <div className="row modal-content-details">
            <div className="col-lg-6">
              <div className="details">
                <div className="table-title">Basic Information</div>
                <div className="details-table">
                  <div>Patient ID</div>
                  <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                  <div>Type of Patient</div>
                  <div>
                    {activePatientJourneyModuleDetails?.type_of_patient}
                  </div>
                  <div>Today’s Date</div>
                  <div>{formatDateToDDMMYYYY(new Date())}</div>
                  <div>Hospital ID</div>
                  <div>{activePatientJourneyModuleDetails?.hospital_id}</div>
                  <div>Type of treatment</div>
                  <div>
                    {activePatientJourneyModuleDetails?.type_of_treatment}
                  </div>
                </div>
              </div>
              <div className="details">
                <div className="table-title">Partner Information</div>
                <div className="details-table">
                  <div>Name</div>
                  <div>
                    {activePatientJourneyModuleDetails?.partner_full_name}
                  </div>
                  <div>DOB</div>
                  <div>
                    {activePatientJourneyModuleDetails?.partner_dob
                      ? formatDateToDDMMYYYY(
                          activePatientJourneyModuleDetails?.partner_dob
                        )
                      : ""}
                  </div>
                  <div>Age</div>
                  <div>{calculateAges.partnerAge}</div>
                  <div>Blood Group</div>
                  <div>
                    {activePatientJourneyModuleDetails?.partner_blood_group}
                  </div>
                  <div>ID Card</div>
                  <div>
                    {activePatientJourneyModuleDetails?.partner_id_card}
                  </div>
                  <div>Partner Photo</div>
                  <div>{/* <a href="">Click to view</a> */}</div>
                  <div>ID Proof</div>
                  <div>{/* <a href="">Click to view</a> */}</div>
                </div>
              </div>
              <div className="details">
                <div className="table-title">Address</div>
                <div className="details-table">
                  <div>Street Address</div>
                  <div>{activePatientJourneyModuleDetails?.street_address}</div>
                  <div>City</div>
                  <div>{activePatientJourneyModuleDetails?.city}</div>
                  <div>State</div>
                  <div>{activePatientJourneyModuleDetails?.state}</div>
                  <div>Nationality</div>
                  <div>{activePatientJourneyModuleDetails?.nationality}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="details">
                <div className="table-title">Patient Information</div>
                <div className="details-table">
                  <div>Name</div>
                  <div>
                    {activePatientJourneyModuleDetails?.patient_full_name}
                  </div>
                  <div>DOB</div>
                  <div>
                    {activePatientJourneyModuleDetails?.patient_dob
                      ? formatDateToDDMMYYYY(
                          activePatientJourneyModuleDetails?.patient_dob
                        )
                      : ""}
                  </div>
                  <div>Age</div>
                  <div>{calculateAges.patientAge}</div>
                  <div>Blood Group</div>
                  <div>
                    {activePatientJourneyModuleDetails?.patient_blood_group}
                  </div>
                  <div>ID Card</div>
                  <div>
                    {activePatientJourneyModuleDetails?.patient_id_card}
                  </div>
                  <div>Patient Photo</div>
                  <div>{/* <a href="">Click to view</a> */}</div>
                  <div>ID Proof</div>
                  <div>{/* <a href="">Click to view</a> */}</div>
                </div>
              </div>
              <div className="details">
                <div className="table-title">Contact Information</div>
                <div className="details-table">
                  <div>Patient Email</div>
                  <div>{activePatientJourneyModuleDetails?.patient_email}</div>
                  <div>Patient Mobile No.</div>
                  <div>
                    {activePatientJourneyModuleDetails?.patient_mobile_no}
                  </div>
                  <div>Partner Email</div>
                  <div>{activePatientJourneyModuleDetails?.partner_email}</div>
                  <div>Partner Mobile No.</div>
                  <div>
                    {activePatientJourneyModuleDetails?.partner_mobile_no}
                  </div>
                </div>
              </div>
              <div className="details">
                <div className="table-title">Other Information</div>
                <div className="details-table">
                  <div>Anniversary</div>
                  <div>
                    {activePatientJourneyModuleDetails?.anniversary
                      ? formatDateToDDMMYYYY(
                          activePatientJourneyModuleDetails?.anniversary
                        )
                      : ""}
                  </div>
                  <div>Allergy</div>
                  <div>{activePatientJourneyModuleDetails?.allergy}</div>
                  <div>Reference Type</div>
                  <div>{activePatientJourneyModuleDetails?.reference_by}</div>
                  <div>Reference</div>
                  <div>{activePatientJourneyModuleDetails?.agent_name}</div>
                  <div>Senior Consultant</div>
                  <div>
                    {activePatientJourneyModuleDetails?.senior_consultant}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="cmn_table_wrap table_wrapper mb-2">
            <div className="table-title">Basic Information</div>

            <Table columns={columns} 
            dataSource={activePatientJourneyModuleDetails?.}
            pagination={false} />
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default PatientRegistrationModal;
